
/* injects from baggage-loader */

'use strict';

export default function (app) {
	app.service('User', function (Parse, $q, $state, $location, $log, UserSchema) {

		// ==================================================
		// Methods
		// ==================================================

		// Hold users roles
		this.roles = [];
		this.fetchedRoles = false;


		/**
		 * Returns the current user
		 */
		this.getCurrent = () => Parse.User.current();


		/**
		 * Returns true if a User is currently logged in
		 */
		this.isUserLoggedIn = () => this.getCurrent() ? true : false;


		/**
		 * Authenticate user login credentials and grant access to the portal if successful
		 */
		this.authenticate = (creds, destination = 'account.home') => {

			// $log.log('Login authenticate method called', new Date());

			// Clear any roles
			this.roles = [];
			this.fetchedRoles = false;

			let d = $q.defer();

			// Contact the server and attempt to authenticate the User
			Parse.User.logIn(creds.email, creds.password)
				.then(user => {

					// NOTE: this freezes login process if run with await , Fetch roles
					this.fetchRoles();
					this.fetchedRoles = true;

					// Login successful
					d.resolve(true);

					// Navigate to destination page
					// if (destination !== false) {
					// 	$state.go(destination);
					// }

				})
				.catch(err => d.reject(err));

			return d.promise;

		}


		/**
		 * Logout current User
		 */
		this.logout = (destination = 'login', error_destination = 'login') => {

			let d = $q.defer();

			Parse.User.logOut()
				.then(user => {
					d.resolve();

					// Navigate to destination page
					$state.go(destination);
					// $location.url('/account/login');
					// $location.replace();

				})
				.catch(err => {
					d.resolve();

					// Navigate to error handled destination page
					$state.go(error_destination);
					// $location.url('/account/login');
					// $location.replace();

				});

			return d.promise;
		}


		/**
		 * Create a new User account
		 */
		this.signup = user => {

			let d = $q.defer();

			// Check for current user, reject signup if true
			if (this.isUserLoggedIn === true) {
				d.reject('Cannot process signup, a user is already logged in.');
			}


			// Set username
			user.username = user.email;

			// Copy the user data
			let new_user = JSON.parse(JSON.stringify(user));

			// Remove the duplicate password
			delete new_user.password_verify;

			// Create a new Parse User object
			let newUser = new Parse.User(new_user);

			// Contact the server and tell it we want to create a new User
			newUser.signUp()
				.then(_user => {
					d.resolve(_user);
				})
				.catch(err => {
					// Signup failed, return error
					d.reject(err);
				});

			return d.promise;

		}


		/**
		 * Send an email to the user with instructions to reset their password
		 */
		this.resetPassword = email => {

			let d = $q.defer();

			Parse.User.requestPasswordReset(email)
				.then(() => {
					d.resolve(true);
				})
				.catch(err => {
					d.reject(err);
				});

			return d.promise;

		}


		/**
		 * Fetch the roles a user belongs to and save in the memory of this server
		 */
		this.fetchRoles = () => {

			let d = $q.defer();

			// Fetch user roles
			if (this.isUserLoggedIn && this.getCurrent() && this.getCurrent().elevated) {
				(new Parse.Query(Parse.Role)).find()
					.then(roles => {
						this.roles = roles;
						// $log.log('Roles:', roles)
						this.fetchedRoles = true;
						d.resolve(roles);
					})
					.catch(err => d.reject(err));
			} else {
				this.fetchedRoles = true;
				// $log.log('No roles, regular user')
				d.resolve([]);
			}

			return d.promise;

		}


		/**
		 * Returns true if the user belongs to the role 
		 */
		this.hasRole = name => this.roles.find(role => role.getName() === name) ? true : false;


		/**
		 * Returns true if the user belongs to the role 
		 */
		this.hasRoleAsync = async name => {
			if (!this.fetchedRoles) await this.fetchRoles();
			// Need to fetch roles if checking for role and not yet retrieved
			return this.roles.find(role => role.getName() === name) ? true : false;
		}

	});
}




// WEBPACK FOOTER //
// ./src/app/core/services/user.service.js